module.exports = __webpack_public_path__ + "img/signin.5750d971.png";